<template>
  <v-flex xs12 sm8>
    <v-layout row wrap class="kennZahlFormel" justify-start>
      <span class="kennZahlFormelTitle" v-if="formel.title">{{ formel.title }}</span>
      &nbsp;<span v-if="showValue && formel.value" class="countertitle">(</span>
      <span v-if="showValue && formel.value" class="countertitle" style="font-weight: 600;color: #8ACAC1;">{{
          formel.value
        }} €</span>
      <span v-if="showValue && formel.value" class="countertitle">)</span>
      <v-spacer>
      </v-spacer>
      <v-btn icon @click="toggleHead()">
        <v-icon>font_download</v-icon>
      </v-btn>
      <v-btn icon @click="toggleValue()">
        <v-icon>toll</v-icon>
      </v-btn>
    </v-layout>
    <v-layout row wrap class="kennZahlFormel" justify-start>
    <v-layout row wrap class="kennZahlFormel" justify-start v-for="(formula, f) in formel.formulas" v-bind:key="f">
      <v-flex v-if="formula.counter" xs12 class="pb-1" justify-start>
        <div>
          <span v-for="(counter, c) in formula.counter" v-bind:key="c">
            <span v-if="counter.id" @click="addChild(formula.counter, counter, -1)" class="counterText">
              <sub class="counterSP">{{ counter.id }} {{ counter.type }}</sub>
              <span :style="getTextStyle(counter)" v-if="showHead">{{ counter.text }}</span>
            <span v-if="showValue && counter.value" class="countertitle">(</span>
              <span v-if="showValue && counter.value" class="counter countertitle"
                    style="font-weight: 600;color: #8ACAC1;">{{ counter.value }} €</span>
              <span v-if="showValue && counter.value" class="countertitle">)</span>
            </span>
            <span v-if="!counter.id" v-html="counter.text" class="countermal mx-1"
                  :style="getTextStyle(counter)"></span>
            <span v-if="counter.factor">
              <span class="sFactor"> &times; {{ counter.factor }}</span>
            </span>
          </span>
        </div>

      </v-flex>
      <v-flex xs12 class="pa-0">
        <div style="border-top: 1px solid black; margin-top:5px; margin-bottom:5px;width:50%;margin-left: auto; margin-right: auto">

        </div>
      </v-flex>
      <v-flex v-if="formula.demoninator" justify-start>
        <span v-if="formula.demoninator">
          <span v-for="(denominator, d) in formula.demoninator" v-bind:key="d">
            <!-- @click="addChild(formula.demoninator, denominator, -1)"  -->
            <span v-if="denominator.id" class="denominatorText">
              <sub class="denominatorSP">{{ denominator.id }} {{ denominator.type }}</sub>
              <span :style="getTextStyle(denominator)" v-if="showHead">{{ denominator.text }}</span>
              <span v-if="showValue && denominator.value" class="countertitle">(</span>
                <span v-if="showValue && denominator.value" class="counter countertitle" style="font-weight: 600;color: #8ACAC1;">{{ denominator.value }} €</span>
                <span v-if="showValue && denominator.value" class="countertitle">)</span>
              </span>
            <span v-if="!denominator.id" v-html="denominator.text" class="denominator mx-1" :style="getTextStyle(denominator)"></span>
              <span v-if="denominator.factor"><span class="sFactor"> &times; {{ denominator.factor }}</span>
            </span>
          </span>
        </span>
      </v-flex>
    </v-layout>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: 'FormelView',
  props: ['formel'],
  data () {
    return {
      showValue: false,
      showHead: true
    }
  },
  methods: {
    myMethod: function () {
    },
    toggleValue () {
      this.showValue = !this.showValue
      if (!this.showValue) {
        this.showHead = true
      }
    },
    toggleHead () {
      this.showHead = !this.showHead
      if (!this.showHead) {
        this.showValue = true
      } else {
        this.showValue = false
      }
    },
    addChild (parent, item, index) {
      console.log('add', index)
      if (index < 0) {
        this.formelSet.kennZahlFormel = []
      } else {
        if (this.formelSet && this.formelSet.kennZahlFormel) {
          this.formelSet.kennZahlFormel = this.formelSet.kennZahlFormel.slice(0, index + 1)
        }
      }
      console.log('add', index, this.formelSet.kennZahlFormel.length)
      if (item.kennZahlFormel && item.kennZahlFormel.length > 0) {
        this.formelSet.kennZahlFormel.push(item.kennZahlFormel[0])
      }
      this.formelSet.expandDetailPanel = []
      for (var i in this.formelSet.kennZahlFormel) {
        this.formelSet.expandDetailPanel.push(true)
      }
      console.log('add', item)
    },
    getTextStyle (item) {
      console.log('item.text', item.text)
      let style = ''
      let textStyle = ['+', '-', '&ndash;']
      let idx = textStyle.indexOf(item.text + '')
      if (idx > -1) {
        style =  'color: #4C4C4C; font-size: 18px;font-weight: 600;'
      }
      let textStyle2 = ['&times; 100']
      idx = textStyle2.indexOf(item.text + '')
      if (idx > -1) {
        style =  'font-size: 16px;font-weight: 600; color: #004884;'
      }
      let textStyle3 = ['Formel 1:', 'Formel 2:']
      idx = textStyle3.indexOf(item.text + '')
      if (idx > -1) {
        style =  'font-size: 13px;font-weight: 600; color: #B2B2B2; padding-right:20px;text-transform: uppercase;'
      }
      return style
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.sFactor {
  font-size: 16px;
  font-weight: 600;
  color: #004884;
}

.countermal{
  font-size: 18px;
  font-weight: 600;
  color: #004884;
}

.kennZahlFormel{
  text-align: center;
}
.countertitle{
  font-size: 18px;
  margin-top: -5px;
}

.kennZahlFormelTitle{
  text-transform: uppercase;
  color: #004884;
}

.kennZahlFormelTitle:after {
  content: ".";
  color:transparent;
  border-bottom:#8ACAC1 2px solid;
  width:100%;
  display:block;
  margin:0 auto;
  margin-left: 0px;
  margin-top: -15px;
}

.endformel{
  text-transform: uppercase;
  color: #545454;
  margin-left: 18px;
}
.denominator {
}
.counter {
}
.denominatorText {
  color: black;
  font-weight: lighter;
  font-size: 14px;
}

.counterText {
  color: black;
  font-weight: lighter;
  font-size: 14px;
}
.denominatorSP{
  color: #7F7F7F;
  font-weight: 600;
  font-size: 14px;
}
.counterSP {
  color: #7F7F7F;
  font-weight: 600;
  font-size: 14px;
}
sub{
  bottom: -0.5em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/FormelView.vue